// Deterministic monogram tiles for records without an uploaded image (products today).
// A small set of muted tones keeps the catalogue calm while making every card distinct;
// the same name always lands on the same tone.

const MONOGRAM_TONES = [
  { background: '#e8efdc', color: '#55682f' }, // sage
  { background: '#ece9e2', color: '#6b6455' }, // stone
  { background: '#e3ebee', color: '#4f6b76' }, // mist
  { background: '#f2ead9', color: '#7a6634' }, // sand
  { background: '#f0e3dd', color: '#7c5343' }, // clay
  { background: '#e4ede4', color: '#4e6b51' }, // moss
];

export const monogramTone = (name: string): { background: string; color: string } => {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = (hash * 31 + name.charCodeAt(i)) % 997;
  }
  return MONOGRAM_TONES[hash % MONOGRAM_TONES.length];
};

export const monogramInitials = (name: string): string => {
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return '?';
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return (words[0].charAt(0) + words[1].charAt(0)).toUpperCase();
};
